import React, { useState, useEffect } from "react";
import { injectModels } from "../redux/injectModels";
import { useParams, Link } from "react-router-dom";
import { routes } from "../constants/routes";
import { handleConsoleError } from "../utils/common-methods";
import { AuthService } from "../services";
import { JWT } from "../shared";


function UserEmailChangeVerification(props) {
  const { token } = useParams();
   const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch data when the component is loaded
    const emailConfirmation= async ()=>{
  var data = { Token: token };
  try {
        const response = await AuthService.confirmEmailChange(data);
          if (response?.isSuccess) {
      setData(response?.message);
        JWT.removeJWT();
          AuthService.removeLoginUser();
          localStorage.clear();
      
          }
          else{
             setError(response?.message);
          }
      } catch (err) {
          const message= handleConsoleError(err);
       setError(err?.message || message);
      }
    }
  emailConfirmation();
  }, []); // Empty array means this effect runs once when the component mounts

  return (
    <React.Fragment>
      <section className="loginswallow-dashboard">
        <div
          style={{
            textAlign: "center",
            marginTop: "100px",
            minHeight: "300px",
          }}
        >
          <h1>Email Change Verification</h1>
          {data && (
            <div>
              <p>Your account email has been changed successfully.</p>
              <Link to={routes.DEFAULT}>Go to Home</Link>
            </div>
          )}
          {error && (
            <div>
              <p>{error}. Please try again.</p>
            </div>
          )}
        </div>
      </section>
    </React.Fragment>
  );
}
export default injectModels(["admin", "application"])(UserEmailChangeVerification);
